import { Box, Button, Typography } from "@dealer-center/core-components";
import type { SectionKey } from "./hashConfig";
import { SECTION_CONFIG } from "./sectionConfig";

export interface SectionGroupProps {
  keys: SectionKey[];
  onSelect: (section: SectionKey) => void;
  title: string;
}

export const SectionGroup = ({ keys, onSelect, title }: SectionGroupProps) => (
  <Box>
    <Typography
      sx={{
        color: "text.secondary",
        fontSize: "0.7rem",
        fontWeight: "bold",
        letterSpacing: "0.08em",
        mb: 1,
        textTransform: "uppercase"
      }}
      variant="body-md"
    >
      {title}
    </Typography>
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
      {keys.map(key => (
        <Button
          analyticsConfiguration={{
            eventName: `PagesLeadManagerUi DemoNav ${key}`
          }}
          buttonStyle="secondary"
          key={key}
          onClick={() => onSelect(key)}
        >
          {SECTION_CONFIG[key].label}
        </Button>
      ))}
    </Box>
  </Box>
);
